/**
 * 工具类
 */
import { secret } from '@/utils/secret';
import CryptoJS from 'crypto-js';
const keyStr = secret;

// 加密
export const encrypt = (word, mode = 'ECB') => {
  try {
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let plaintText = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(plaintText, key, {
      iv: mode == 'CBC' ? key : null,
      mode: CryptoJS.mode[mode],
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  } catch (error) {
    console.log(error);
  }
};

// 解密
export const decrypt = (word, mode = 'ECB') => {
  try {
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let decrypt = CryptoJS.AES.decrypt(word, key, {
      iv: mode == 'CBC' ? key : null,
      mode: CryptoJS.mode[mode],
      padding: CryptoJS.pad.Pkcs7,
    });
    // console.log('解密前：', word);
    // console.log('解密后：', CryptoJS.enc.Utf8.stringify(decrypt).toString());
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  } catch (error) {
    console.log(error);
  }
};
